import { render, staticRenderFns } from "./CommunicationPage.vue?vue&type=template&id=1aabfdff&scoped=true"
import script from "./CommunicationPage.vue?vue&type=script&lang=js"
export * from "./CommunicationPage.vue?vue&type=script&lang=js"
import style0 from "./CommunicationPage.vue?vue&type=style&index=0&id=1aabfdff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aabfdff",
  null
  
)

export default component.exports